import type { LevelCosmeticEntry } from '../types'

interface ResolveNewlyUnlockedCosmeticArgs {
  levelId: number | null
  previousCosmetics: LevelCosmeticEntry[]
  nextCosmetics: LevelCosmeticEntry[]
}

function isEligibleLevelAvatar(entry: LevelCosmeticEntry, levelId: number | null) {
  if (levelId === null) return false

  return (
    entry.kind === 'avatar' &&
    entry.criteria.level_ids?.includes(levelId) &&
    entry.status === 'unlocked'
  )
}

export function resolveNewlyUnlockedCosmetic({
  levelId,
  previousCosmetics,
  nextCosmetics
}: ResolveNewlyUnlockedCosmeticArgs): LevelCosmeticEntry | null {
  const previousUnlockedIds = new Set(
    previousCosmetics
      .filter(entry => isEligibleLevelAvatar(entry, levelId))
      .map(entry => entry.id)
  )

  return (
    nextCosmetics.find(
      entry =>
        isEligibleLevelAvatar(entry, levelId) && !previousUnlockedIds.has(entry.id)
    ) ?? null
  )
}
